var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('alert-error',{attrs:{"error":_vm.error}}),_c('v-card-text',[_c('helper',{attrs:{"relations":_vm.relations || []},on:{"show":_vm.show}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }